import React, { memo } from 'react';
import classNames from 'classnames';
import { Icon } from 'modules/ui';
import styles from './OptionUI.module.scss';

function OptionUI({
  isCheckbox = false,
  selected,
  disabled,
  label,
  menuStyle,
  containerStyle,
  onClick,
  divider = false,
}) {
  const containerClasses = classNames(styles.container, {
    [styles.disabled]: disabled,
    [styles['with-divider']]: divider,
    [styles['menu--selected']]: menuStyle && selected,
  });

  const iconClasses = classNames(styles.icon, {
    [styles['icon--multiselect']]: isCheckbox,
    [styles['icon--selected']]: selected,
  });

  const showIcon = !menuStyle;

  function handleKeyDown(event) {
    if (disabled) {
      return;
    }

    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      onClick();
    }
  }

  return (
    <div
      role="option"
      aria-selected={selected}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      style={containerStyle}
      className={containerClasses}
      onClick={disabled ? null : onClick}
      onKeyDown={handleKeyDown}
    >
      {showIcon && (
        <div>
          <div className={iconClasses}>
            {selected && <Icon name="checked" color="#fff" size={24} />}
          </div>
        </div>
      )}
      <span>{label}</span>
    </div>
  );
}

export default memo(OptionUI);
